import { WalletError } from '@solana/wallet-adapter-base';
export class WalletNotSelectedError extends WalletError {
}
//# sourceMappingURL=errors.js.map